import { client } from '../../client';
import {
  TeacherLiveClassGetStudentsDocument,
  TeacherLiveClassGetStudentsQuery,
  TeacherLiveClassGetStudentsQueryVariables,
  TeacherMeetingCreateDocument,
  TeacherMeetingCreateMutation,
  TeacherMeetingCreateMutationVariables,
  TeacherMeetingDeleteDocument,
  TeacherMeetingDeleteMutation,
  TeacherMeetingDeleteMutationVariables,
  TeacherMeetingJoinDocument,
  TeacherMeetingJoinMutation,
  TeacherMeetingJoinMutationVariables,
} from '../types';

export async function createLiveClass(variables: TeacherMeetingCreateMutationVariables) {
  try {
    const response = await client.mutate<TeacherMeetingCreateMutation, TeacherMeetingCreateMutationVariables>({
      mutation: TeacherMeetingCreateDocument,
      variables,
    });
    return response.data.create_live_class;
  } catch (e) {
    throw e;
  }
}

export async function teacherCreateMeeting(variables: TeacherMeetingCreateMutationVariables) {
  try {
    const response = await client.mutate<TeacherMeetingCreateMutation, TeacherMeetingCreateMutationVariables>({
      mutation: TeacherMeetingCreateDocument,
    });

    return response.data;
  } catch (e) {
    throw e;
  }
}

export async function teacherJoinMeeting(variables: TeacherMeetingJoinMutationVariables) {
  try {
    const response = await client.mutate<TeacherMeetingJoinMutation, TeacherMeetingJoinMutationVariables>({
      mutation: TeacherMeetingJoinDocument,
      variables,
    });
    return response.data.teacherJoin;
  } catch (e) {
    throw e;
  }
}

export async function teacherDeleteMeeting(variables: TeacherMeetingDeleteMutationVariables) {
  try {
    const response = await client.mutate<TeacherMeetingDeleteMutation, TeacherMeetingDeleteMutationVariables>({
      mutation: TeacherMeetingDeleteDocument,
      variables,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
}
